import { render, staticRenderFns } from "./UserOrdersInfo.vue?vue&type=template&id=75f4a2d6&scoped=true"
import script from "./UserOrdersInfo.vue?vue&type=script&lang=js"
export * from "./UserOrdersInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75f4a2d6",
  null
  
)

export default component.exports